import { createApiCall } from 'services'
import { getErrorMessage } from 'utils'


import type { GetActionLogByIdPayload, GetActionLogByIdResponse } from './types'
import type { ActionCallback } from '../model'

import { call, put, fork, takeLatest } from 'redux-saga/effects'

import { Actions } from './types'





export function* getActionLogByIdSaga(): Generator {
  yield takeLatest(Actions.GET_ACTION_LOG, function* (action: ActionCallback<GetActionLogByIdPayload>) {
    try {
      const { payload, callback } = action
      const { id: certificateId, ...rest } = payload

      const response: GetActionLogByIdResponse = yield call(createApiCall, {
        url: `/action-log/${certificateId}`,
        params: rest,
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: Actions.SET_ACTION_LOG,
          payload: data,
        })
      }

      callback && callback({ success: true, content: data })
    } catch (e) {
      console.error(e)
      action.callback && action.callback({ success: false, content: getErrorMessage(e) })
    }
  })
}

export default [fork(getActionLogByIdSaga)]
